export default __webpack_public_path__ + "static/media/Standard30.79cbe699.png";